import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PortalProductSubscription, PortalProductsSubscriptionsService } from '@fgb/core';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'fgb-subscriptions-list-item-subscribed',
  templateUrl: './subscriptions-list-item-subscribed.component.html',
  styleUrls: ['./subscriptions-list-item-subscribed.component.scss'],
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [
        style({ height: '0', opacity: '0', overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: '1' })),
      ]),
      transition(':leave', [style({ overflow: 'hidden' }), animate('250ms ease-in', style({ height: '0', opacity: '0' }))]),
    ]),
  ],
})
export class SubscriptionsListItemSubscribedComponent implements OnInit {
  @Input() subscribedProduct: PortalProductSubscription;
  currentSubscribedProduct: PortalProductSubscription;
  currentLcid: string | null = '';
  isExpanded = false;
  autoRenewal = false;

  get daysLeft(): number {
    if (!this.currentSubscribedProduct?.NextPaymentDueDate) return 0;
    const diff = new Date(this.currentSubscribedProduct.NextPaymentDueDate).getTime() - Date.now();
    return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
  }
  constructor(
    private modalService: NgbModal,
    private portalProductsSubscriptionsService: PortalProductsSubscriptionsService
  ) {
    this.currentLcid = localStorage.getItem('lcid');
  }

  ngOnInit() {
    this.updateStatus();
  }

  updateStatus() {
    if (this.subscribedProduct.ProductType === 3) {
      this.currentSubscribedProduct = this.subscribedProduct;
      this.autoRenewal = this.currentSubscribedProduct.AutoRenewalStatus;
    }
  }

  toggleAutoRenewal() {
    const id = this.currentSubscribedProduct.SubscriptionId;
    if (this.autoRenewal) {
      this.portalProductsSubscriptionsService.deactivateSubscription(id).subscribe(() => {
        this.autoRenewal = false;
      });
    } else {
      this.portalProductsSubscriptionsService.activateSubscription(id).subscribe(() => {
        this.autoRenewal = true;
      });
    }
  }

  openProductDescription(content: any) {
    this.modalService.open(content, { centered: true });
  }
}
